import { User } from '@/pages/user/schema/user';
import { sysOpsUserService } from '@/services/sys-ops-user-service';
import { clearToken } from '@/utils/token';
import { getPageQuery } from '@/utils/utils';
import { stringify } from '@ant-design/pro-components';
import { history } from '@umijs/max';
import { plainToInstance } from 'class-transformer';
import useSWR from 'swr';

export function useUser(id?: string) {
  return useSWR(
    () => (id ? ['sysOpsUserService.sysOpsFindUser', id] : null),
    () => sysOpsUserService.sysOpsFindUser(id!, { silent: true }).then((res) => plainToInstance(User, res)),
  );
}

/**
 * 退出登录，并且将当前的 url 保存
 */
export const logOut = async () => {
  // 清理登录信息
  clearToken();
  const { redirect } = getPageQuery();
  if (window.location.pathname !== '/user/login' && !redirect) {
    history.replace({
      pathname: '/auth/login',
      search: stringify({
        redirect: window.location.href,
      }),
    });
  }
};
